var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 left-0 bg-luxcaddy-600 text-white font-bold px-1 text-sm sm:text-md sm:px-2 py-1 border-b border-r border-gray-400 shadow"},[_vm._v(" BIO ")])
}
var staticRenderFns = []

export { render, staticRenderFns }